import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.shared-accounts.notes', {
        url: '/notes',
        views: {
            '': 'userSharedNotes',
            'header@user': 'userSharedAccountsHeader',
        },
        resolve: {sharedNotes},
    })
}

/** @ngInject */
function sharedNotes( UsersSharedAccountService) {
    return UsersSharedAccountService.usersSharedNotes.getUsersSharedNotes().$promise
}





// WEBPACK FOOTER //
// ./src/portal/states/user/users-shared-accounts/users-shared-notes.state.js